var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-main" }, [
    _c("div", { staticClass: "vertify-title" }, [_vm._v("个人认证")]),
    _vm._v(" "),
    _c("div", { staticClass: "vertify-li spaceLeft" }, [
      _c("div", { staticClass: "vertify-li-title" }, [_vm._v("用户名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "width-auto" }, [
        _vm._v(
          "\n      " +
            _vm._s(this.utils.xxShow("name", this.sessionData.loginName)) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vertify-li spaceLeft" }, [
      _c("div", { staticClass: "vertify-li-title" }, [_vm._v("手机号码")]),
      _vm._v(" "),
      _c("div", { staticClass: "width-auto" }, [
        _vm._v(_vm._s(this.sessionData.mobile))
      ]),
      _vm._v(" "),
      _c("div")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "vertify-li spaceLeft" }, [
      _c("div", { staticClass: "vertify-li-title" }, [_vm._v("用户状态")]),
      _vm._v(" "),
      _c("div", { staticClass: "width-auto" }, [
        _vm._v(_vm._s(_vm.statusArr[_vm.userObj.status].text))
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.userObj.status == 2 || _vm.userObj.status == 1
            ? _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("info")
                    }
                  }
                },
                [_vm._v("查看详情")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userObj.status == 0
            ? _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("edit")
                    }
                  }
                },
                [_vm._v("去认证")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userObj.status == 3
            ? _c(
                "a-button",
                {
                  attrs: { type: "link" },
                  on: {
                    click: function($event) {
                      return _vm.toPage("edit")
                    }
                  }
                },
                [_vm._v("修改")]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e004f14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e004f14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/personalAuthentication/index.vue
// module id = 6ri5
// module chunks = 1